module.exports = __webpack_public_path__ + "media/img/vca/bg-popup-7ba4becdd16657c9752937053dc6d69f.png";